<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="工序详情"
      id-key="UserId"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <el-table border class="table_bottom table-line tb-c-head" :data="tableData">
        <el-table-column prop="ProgrammeName" label="工艺方案名称" min-width="120"></el-table-column>
        <el-table-column prop="ProcessSn" label="工序顺序" min-width="120"></el-table-column>
        <el-table-column prop="ProcessName" label="工序名称" min-width="120"></el-table-column>
        <el-table-column prop="ProductionType" label="自制工序或者委外工序" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.ProcessType" @change="changeProcessType(row)">
              <el-option key="a1" label="自制工序" :value="0"></el-option>
              <el-option key="a2" label="委外工序" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
          <template slot-scope="{ row }">
            <div class="flex" v-show="row.ProcessType === 1">
              <el-input type="text" v-model="row.FullName" readonly />
              <el-button type="primary" @click="selectCome(row)">选择</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
      <come-list-dialog
        @select="comeSelect"
        selectable
        :multiple="false"
        ref="comeListDialog"
        in-dialog
      />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import comeListDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    comeListDialog,
  },
  data() {
    return {
      tableData: [],
      currentRow: null,
    };
  },
  methods: {
    selectCome(row) {
      this.currentRow = row;
      this.$refs.comeListDialog.open().then(that => {
        that.getData({TradeUnitType: 3})
      })
    },
    changeProcessType(row) {
      if (row.T !== 0) row.T = 1;
    },
    comeSelect(row) {
      console.log("row", row);
      this.currentRow.DpId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1;
      }
    },
    setTableData(row) {
      let arr = [];
      console.log("setTableData", row);
      row.Processes.forEach((item) => {
        // let o = {
        //   T: item.T === 1 ? 1 : 0,
        //   ProgrammeName: row.ProgrammeName,
        //   ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
        //   ProcessId: item.ProcessId,
        //   ProcessName: item.ProcessName,
        //   ProcessNo: item.ProcessNo,
        //   ProgrammeId: item.ProgrammeId,
        //   ProgrammeName: item.ProgrammeName,
        //   TeProductId: item.TeProductId ?? 0,
        //   TeProductProcessId: item.TeProductProcessId ?? 0,
        //   Stage: item.Stage,
        //   ProcessType: item.ProcessType == null ? "" : item.ProcessType,
        //   DpId: item.DpId ? item.DpId : 0,
        //   TradeUnitName: item.FullName ? item.FullName : "",
        // };
        arr.push({
          ...item,
          T: item.T === 1 ? 1 : 0,
          ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
          TeProductId: item.TeProductId ?? 0,
          TeProductProcessId: item.TeProductProcessId ?? 0,
          ProcessType: item.ProcessType == null ? "" : item.ProcessType,
          DpId: item.DpId ? item.DpId : 0,
        });
      });
      this.tableData = arr;
      console.log("set tableData", this.tableData);
    },
    save() {
      console.log("this.tableData", this.tableData);

      let data = this.tableData.filter((item) => {
        return item.T != null;
      });
      console.log("data", data);
      this.$emit("saved", data);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
